import { connect } from "react-redux";

var DataExportMetrics = require("lib/data/DataExportMetrics.js")
var CurrentUser = require("lib/account/CurrentUser");
var WeekPicker = require("components/utility/date-pickers/WeekPicker")
var MonthPicker = require("components/utility/date-pickers/MonthPicker")

import moment from "moment";
import DatePicker from "react-datepicker";

require("data/exports/exports_date_span_selector.scss");

@connect(
    (state, props) => {
        return { expectationsDateSpans: CurrentUser.get().expectations_date_spans }
    },
    (dispatch, props) => ({})
)

class ExportsDateSpanSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDatePeriod: props.persistentData.selectedDatePeriod || 'custom',
            startDate: props.persistentData.startDate || null,
            endDate: props.persistentData.endDate || null,
            selectedGoalPeriodStart: props.persistentData.selectedGoalPeriodStart || null,
            selectedGoalPeriodEnd: props.persistentData.selectedGoalPeriodEnd || null
        };
    }

    ///// HELPERS /////
    initDateSelections() {
        return {
            startDate: null,
            endDate: null,
            selectedGoalPeriodStart: null,
            selectedGoalPeriodEnd: null
        }
    }

    renderErrorAlert(text) {
        window.wrNotifications.triggerDropDownNotification({
            text: text,
            icon: "exclamation-sign", type: "error"
        }, 3000);
    }

    selectedOrganizationType() {
        var { persistentData } = this.props
        if (_.has(persistentData, 'selectedOrganizationType')) {
            return persistentData.selectedOrganizationType
        }
    }

    chronoOrganizationType() {
        return (
            this.selectedOrganizationType() &&
            this.selectedOrganizationType() == 'chrono'
        )
    }

    selectedMetricCategory() {
        var { persistentData } = this.props
        if (_.has(persistentData, 'selectedMetricCategory')) {
            return persistentData.selectedMetricCategory
        }
    }

    goalMetricCategory() {
        return (
            this.selectedMetricCategory() &&
            this.selectedMetricCategory() == 'goals'
        )
    }

    convertStringToDate(string) {
        return this.formatDate(moment(string, "YYYY-MM-DD").toDate());
    }

    // formats all dates the same before sending to state
    formatDate(date) {
        return moment(date).format("YYYY-MM-DD");
    }

    ///// VALIDATORS /////
    validDateRange() {
        var { startDate, endDate } = this.state;

        return startDate && endDate && endDate >= startDate
    }

    validDatePeriod() {
        return _.includes(VALID_DATE_PERIODS, this.state.selectedDatePeriod)
    }

    ///// HANDLERS /////
    handleDatePeriodChange(selectedDatePeriod) {
        this.setState({ selectedDatePeriod, ...this.initDateSelections() })
    }

    handleGoalPeriodStartChange(selectedGoalPeriodStart) {
        var { expectationsDateSpans } = this.props

        var expectationDateSpan = _.findWhere(expectationsDateSpans, { label: selectedGoalPeriodStart })
        if (expectationDateSpan) {
            this.setState({
                selectedGoalPeriodStart,
                startDate: this.convertStringToDate(expectationDateSpan.start),
            })   
        }
    }

    handleGoalPeriodEndChange(selectedGoalPeriodEnd) {
        var { expectationsDateSpans } = this.props

        var expectationDateSpan = _.findWhere(expectationsDateSpans, { label: selectedGoalPeriodEnd })
        if (expectationDateSpan) {
            this.setState({
                selectedGoalPeriodEnd,
                endDate: this.convertStringToDate(expectationDateSpan.end),
            })
        }
    }

    handleStartDateChange(startDate) {
        startDate = this.formatDate(startDate)
        this.setState({ startDate })
    }

    handleEndDateChange(endDate) {
        endDate = this.formatDate(endDate)
        this.setState({ endDate })
    }

    handleStartWeekChange(startDate, endDate, selectedDate) {
        startDate = this.formatDate(startDate)
        this.setState({ startDate })
    }

    handleEndWeekChange(startDate, endDate, selectedDate) {
        endDate = this.formatDate(endDate)
        this.setState({ endDate })
    }

    handleStartMonthChange(startDate, endDate, selectedDate) {
        startDate = this.formatDate(startDate)
        this.setState({ startDate })
    }

    handleEndMonthChange(startDate, endDate, selectedDate) {
        endDate = this.formatDate(endDate)
        this.setState({ endDate })
    }

    handleRetreatStage() {
        var { startDate, endDate, selectedDatePeriod } = this.state

        var newPersistentData = this.validDateRange() ? { startDate, endDate, selectedDatePeriod } : {}
        this.props.onRetreat(newPersistentData)
    }

    ///// SUBMIT /////
    onSubmit() {
        var { startDate, endDate, selectedDatePeriod } = this.state

        if (!this.validDateRange()) {
            this.renderErrorAlert("Please Select a Valid Date Range")
        } else {
            this.props.onComplete({ startDate, endDate, selectedDatePeriod })
        }
    }

    ///// RENDER METHODS /////

    // goal period picker is based on user epxecatation date spans
    renderGoalPeriodPicker() {
        var expectationDateSpans = [
            <option key='defaultOption' value=''>Select a Goal Period</option>,
            ...this.props.expectationsDateSpans.map(d => (
                <option value={d.label} key={d.label}>{d.label}</option>
            ))
        ]

        return (
            <div className="exportsDatePickerContainer">
                <div className="datePicker">
                    <div className="selectLabel">Start Goal Period:</div>
                    <select value={this.state.selectedGoalPeriodStart} onChange={e => this.handleGoalPeriodStartChange(e.target.value)} className="selectElement">
                        {expectationDateSpans}
                    </select>
                </div>
                <div className="datePicker">
                    <div className="selectLabel">End Goal Period:</div>
                    <select value={this.state.selectedGoalPeriodEnd} onChange={e => this.handleGoalPeriodEndChange(e.target.value)} className="selectElement">
                        {expectationDateSpans}
                    </select>
                </div>
            </div>
        )
    }

    renderDatePicker() {
        var { startDate, endDate, selectedDatePeriod } = this.state;

        if (!this.validDatePeriod()) { return null }

        if (selectedDatePeriod == 'goal-period') {
            return this.renderGoalPeriodPicker()
        }
        
        // render date picker based on selected date period
        if (selectedDatePeriod == 'week') {
            var startSelector = <WeekPicker selectedDate={startDate} startDate={startDate} endDate={endDate} onChange={this.handleStartWeekChange.bind(this)} />
            var endSelector = <WeekPicker selectedDate={endDate} startDate={startDate} endDate={endDate} onChange={this.handleEndWeekChange.bind(this)} />
        } else if (selectedDatePeriod == 'month') {
            var startSelector = <MonthPicker selectedDate={startDate} startDate={startDate} endDate={endDate} onChange={this.handleStartMonthChange.bind(this)} />
            var endSelector = <MonthPicker selectedDate={endDate} startDate={startDate} endDate={endDate} onChange={this.handleEndMonthChange.bind(this)} />
        } else {
            var startSelector = <DatePicker className="form-control" selected={startDate ? moment(startDate) : null} onChange={this.handleStartDateChange.bind(this)} />
            var endSelector = <DatePicker className="form-control" selected={endDate ? moment(endDate) : null} onChange={this.handleEndDateChange.bind(this)} />
        }

        return (
            <div className="exportsDatePickerContainer">
                <div className="datePicker">
                    <div className="selectLabel">{`Start ${$wr.toTitleCase(selectedDatePeriod)}`}:</div>
                    {startSelector}
                </div>
                <div className="datePicker">
                    <div className="selectLabel">{`End ${$wr.toTitleCase(selectedDatePeriod)}`}:</div>
                    {endSelector}
                </div>
            </div>
        );
    }

    // selects time periods in which users can specifiy start and end dates
    renderDatePeriodSelector() {      
        var orgTypeKey = this.selectedOrganizationType() ? this.selectedOrganizationType() : 'chrono'
        return (
            <div className="selectContainer">
                <div className="datePeriodLabel">Select a Date Period:</div>
                <select value={this.state.selectedDatePeriod} onChange={e => this.handleDatePeriodChange(e.target.value)} className="selectElement">
                    {DataExportMetrics.DATE_PERIODS_BY_ORG_TYPE[orgTypeKey].map(d => (
                        <option value={d.key} key={d.key}>{d.label}</option>
                    ))}
                    
                </select>
            </div>
        );
    }

    render() {
        // render date period selector if user wants
        // the xls organized by date periods
        if (this.chronoOrganizationType() && !this.goalMetricCategory()) {
            var datePeriodSelector = this.renderDatePeriodSelector()
        }

        var datePicker = this.renderDatePicker()
        return (
            <div className="exportsDateSpanSelectorContainer">
                <div className="dateSelectorsConainer">
                    {datePeriodSelector}
                    {datePicker}
                </div>
                <div className="onSubmitContainer">
                    <button className='backBtn' onClick={() => this.handleRetreatStage()}>Back</button>
                    {this.validDateRange() && (
                        <button className='nextBtn' onClick={() => this.onSubmit()}>Next</button>
                    )}
                </div>
            </div>
        )
    }

    componentDidMount() {
        var { persistentData, expectationsDateSpans } = this.props

        // default selected period to week for chronological export
        if (this.chronoOrganizationType() && _.isEmpty(persistentData.selectedDatePeriod)) {
            if (persistentData.startDate && persistentData.endDate) {
                var startDate = moment(persistentData.startDate).startOf('week').format('YYYY-MM-DD');
                var endDate = moment(persistentData.endDate).endOf('week').format('YYYY-MM-DD');
                this.setState({ startDate, endDate, selectedDatePeriod: 'week' })
            } else {
                this.setState({ selectedDatePeriod: 'week' })
            }
        }

        // default lock into custom date periods for non-chrono exports
        if (!this.chronoOrganizationType()) {
            this.setState({ selectedDatePeriod: 'custom' })
        }

        // if the user seleced to see goal metrics, lock them into selecting goal periods
        if (this.goalMetricCategory()) {
            this.setState({ selectedDatePeriod: 'goal-period' })
            // preselect labels if user is going back in modal sequence
            if (persistentData.startDate && persistentData.endDate && expectationsDateSpans.length) {
                var start = _.findWhere(expectationsDateSpans, { start: persistentData.startDate })
                var end = _.findWhere(expectationsDateSpans, { end: persistentData.endDate })
                if (start && end) {
                    this.setState({ selectedGoalPeriodStart: start.label, selectedGoalPeriodEnd: end.label })
                } else {
                    var goalDateSpan = expectationsDateSpans[0]
                    this.setState({
                        selectedGoalPeriodStart: goalDateSpan.label,
                        selectedGoalPeriodEnd: goalDateSpan.label,
                        startDate: moment(goalDateSpan.start).startOf('day').format('YYYY-MM-DD'),
                        endDate: moment(goalDateSpan.end).startOf('day').format('YYYY-MM-DD')
                    })
                }
            }
        }
    }
}

ExportsDateSpanSelector.propTypes = StrictPropTypes({
    endOnboarding: PropTypes.func,
    handleAdvanceStage: PropTypes.func,
    onSubmit: PropTypes.func,
    onComplete: PropTypes.func,
    onRetreat: PropTypes.func,
    track: PropTypes.array,
    persistentData: PropTypes.object,
    currentAdmin: PropTypes.object,
    organizationTypes: PropTypes.array,
    organizationOptions: PropTypes.array,
    handlePrint: PropTypes.func,
});

var VALID_DATE_PERIODS =['week', 'month', 'goal-period', 'custom']

module.exports = ExportsDateSpanSelector;


// WEBPACK FOOTER //
// ./modules/components/data/exports/ExportsDateSpanSelector.js